import styled from 'styled-components';

export const NoDataMessage = styled.div`
  color: rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    padding: 20px 10px;
  }
`;
